import React from 'react';
import { DocUpload } from './HcSsrTuitionFields';

export const AMOUNT_RE = /^\$?\s*(\d{1,3}(,\d{3})+|\d+)(\.\d{1,2})?$/;
export const isValidAmount = (v) => AMOUNT_RE.test((v || '').trim()) && parseFloat(v.replace(/[$,\s]/g, '')) > 0;

export const HcSsrInternetFields = ({ amount, setAmount, docs, setDocs, field }) => (
  <div className="space-y-4 rounded-2xl bg-[#922A8C]/5 p-4 sm:p-5" data-testid="hc-ssr-internet-section">
    <div>
      <label className="text-sm font-semibold text-[#363636]">Amount requested <span className="text-red-600">*</span></label>
      <div className="relative mt-1">
        <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500">$</span>
        <input type="text" inputMode="decimal" value={amount} placeholder="0.00" maxLength={12}
          onChange={(e) => setAmount(e.target.value.replace(/[^\d.,]/g, ''))} className={`${field} pl-8`} data-testid="hc-ssr-internet-amount" />
      </div>
      <p className="text-xs text-gray-400 mt-1">The dollar amount of your internet bill</p>
    </div>
    <DocUpload kind="internet_bill" title="Internet bill" value={docs.internet_bill} onChange={(v) => setDocs((d) => ({ ...d, internet_bill: v }))} field={field} />
  </div>
);
